import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { LogIn } from 'lucide-react';

const AdminLogin = () => {
  const handleGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/admin/callback';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="bg-void-black min-h-screen flex items-center justify-center px-6">
      <div className="noise-overlay" />
      
      <motion.div 
        className="glass p-12 rounded-lg max-w-md w-full text-center relative z-10"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <h1 className="font-syne font-bold text-3xl text-white mb-2">
          <span className="text-neon-red">Admin</span> Login
        </h1>
        <p className="font-manrope text-neutral-400 mb-8">
          Sign in with Google to access the blog dashboard
        </p>

        <button
          onClick={handleGoogleLogin}
          className="w-full btn-primary py-4 rounded font-manrope font-bold text-sm uppercase flex items-center justify-center gap-3"
        >
          <svg className="w-5 h-5" viewBox="0 0 24 24">
            <path fill="currentColor" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
            <path fill="currentColor" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
            <path fill="currentColor" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
            <path fill="currentColor" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
          </svg>
          Sign in with Google
        </button>

        <p className="font-manrope text-neutral-500 text-xs mt-6">
          Only authorized admins can access this area
        </p>

        <Link 
          to="/"
          className="inline-block mt-8 text-neon-red hover:text-white transition-colors font-manrope text-sm"
        >
          ← Back to Home
        </Link>
      </motion.div>
    </div>
  );
};

export default AdminLogin;
